// extracted by mini-css-extract-plugin
export default {"root":"LGkjnR","icon":"ozZcZ9","activeIcon":"Qdu8za"};